@import '../../theme/global';

:host {
  display: block;
}

.sign-in-manage {
    align-items: center;
    display: flex;
    font-family: $font-family;
    height: 100%;
    justify-content: center;
    left: 0;
    outline: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10001;
    @include box-sizing;

  &-backdrop {
    background-color: rgba(15, 23, 42, 0.25);
    contain: strict;
    display: block;
    inset: 0;
    position: absolute;
    touch-action: none;
    z-index: 2;
  }

  &-container {
    background-color: $base-light;
    border: 1px solid $gray-200;
    border-radius: 10px;
    max-width: 640px;
    padding: 1.5rem 2rem;
    position: relative;
    top: 0;
    width: 100%;
    z-index: 1062;

    h1 {
      color: $gray-800;
      font-size: 30px;
      font-weight: 700;
      line-height: 36px;
      margin: 0 0 1.5rem;

      span {
        color: $product-manage;
      }
    }

    .close-icon {
      cursor: pointer;
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
    }

    .school-search-label {
      color: $gray-800;
      display: inline-block;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.25rem;
      margin-bottom: 0.25rem;
    }

    .select-menu,
    .school-search {
      margin-bottom: 1.5rem;
    }

    .sign-in-manage-footer {
      display: flex;
      justify-content: flex-end;
    }

    .btn-wrapper {
      width: 143px;
    }
  }



}
